const modalStyleFunc = (defaultStyle: ReactModal.Styles): ReactModal.Styles => ({
  ...defaultStyle,
  content: {
    ...defaultStyle.content,
    position: 'initial',
  },
  overlay: {
    ...defaultStyle.overlay,
    background: 'rgba(0, 0, 0, .85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default modalStyleFunc;
